export const useFeatureFlag = (name: string): boolean => {
  const flags = (typeof window !== 'undefined'
    ? (window as { __LOGNAI_FEATURE_FLAGS?: Record<string, boolean> }).__LOGNAI_FEATURE_FLAGS
    : undefined);
  if (flags === undefined) return true;
  const value = flags[name];
  if (value === undefined) return true;
  return value === true;
};
